interface TaskDetailsIconProps {
  size?: number
  className?: string
}

/**
 * **Das Zeichen für die Aufgaben-Details** — ein Fenster mit einer Spalte an
 * der rechten Kante: die Seitenspalte, die der Knopf auf- und zuzieht.
 *
 * Aus dem Entwurf (Figma `5282:208831` „btn Task Details Expand"), Geometrie
 * unverändert übernommen. Zwei Dinge daran sind nicht offensichtlich:
 *
 * **Die Spalte steht auf 70 %** — sie ist die Füllung IM Fenster, nicht der
 * Rahmen selbst, und tritt deshalb einen Schritt zurück. Die Deckkraft sitzt
 * auf der GRUPPE, nicht auf den beiden Pfaden einzeln: Fläche und Strich
 * überlappen sich ein Stück, und zwei halbdurchlässige Lagen übereinander
 * ergäben dort einen dunkleren Saum. Eine Gruppe wird als Ganzes gerechnet.
 *
 * **Der Strich steht auf 1.66 statt 1.33.** Der Entwurf zeichnet auf 20px, die
 * Leiste trägt aber 16px-Zeichen (Liste/Stapel daneben) — `DetailsToggle.scss`
 * zwingt jedes SVG darin auf 16px. In einem 20er-Feld auf 16px gezeichnet
 * ergeben 1.66 dieselben 1.33px wie ein 1.33er Strich in einem 16er-Feld; sonst
 * stünde das Zeichen sichtbar dünner als seine Nachbarn.
 *
 * `currentColor` für Strich und Fläche — der Knopf färbt das Zeichen über
 * seine Zustände (Ruhe, Hover, eingerastet).
 */
export const TaskDetailsIcon = ({ size = 16, className }: TaskDetailsIconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="1.335"
      y="2.335"
      width="17.33"
      height="15.33"
      rx="4.665"
      stroke="currentColor"
      strokeWidth="1.66"
    />
    <g opacity="0.7">
      <path
        d="M11 7.25649C11 6.73488 11 6.47408 11.1321 6.29078C11.1761 6.22969 11.2297 6.1761 11.2908 6.13207C11.4741 6 11.7349 6 12.2565 6H13C13.9428 6 14.4142 6 14.7071 6.29289C15 6.58579 15 7.05719 15 8V12.5C15 12.9659 15 13.1989 14.9239 13.3827C14.8224 13.6277 14.6277 13.8224 14.3827 13.9239C14.1989 14 13.9659 14 13.5 14C13.2239 14 13 13.7761 13 13.5V12.1213C13 11.2561 13 10.8234 12.8851 10.4203C12.822 10.1988 12.7335 9.98533 12.6216 9.78409C12.4178 9.41775 12.1118 9.11183 11.5 8.5C11.2961 8.29606 11.1941 8.19408 11.1261 8.07197C11.0888 8.00489 11.0593 7.93374 11.0383 7.85991C11 7.72553 11 7.58131 11 7.29289V7.25649Z"
        fill="currentColor"
      />
      <path
        d="M13 5.33496C13.4525 5.33496 13.8587 5.33401 14.1855 5.37793C14.5316 5.42446 14.8871 5.53167 15.1777 5.82227C15.4683 6.11286 15.5755 6.4684 15.6221 6.81445C15.666 7.14133 15.665 7.54752 15.665 8V12.5C15.665 12.7239 15.6657 12.9254 15.6543 13.0928C15.6425 13.2659 15.6152 13.4505 15.5381 13.6367C15.3691 14.0447 15.0447 14.3691 14.6367 14.5381C14.4505 14.6152 14.2659 14.6425 14.0928 14.6543C13.9254 14.6657 13.7239 14.665 13.5 14.665C12.8566 14.665 12.335 14.1434 12.335 13.5V12.1211C12.335 11.2185 12.3286 10.8955 12.2451 10.6025C12.196 10.4302 12.1272 10.264 12.04 10.1074C11.8919 9.84124 11.6675 9.60895 11.0293 8.9707C10.8519 8.79333 10.6685 8.61765 10.5449 8.39551C10.4828 8.28382 10.4335 8.16491 10.3984 8.04199C10.3288 7.79757 10.335 7.54373 10.335 7.29297V7.25684C10.335 7.01075 10.3342 6.77238 10.3555 6.5752C10.378 6.36583 10.4319 6.12563 10.5928 5.90234C10.6786 5.78321 10.7832 5.67862 10.9023 5.59277C11.1256 5.43192 11.3658 5.37805 11.5752 5.35547C11.7724 5.33424 12.0107 5.33496 12.2568 5.33496H13Z"
        stroke="currentColor"
        strokeWidth="1.66"
      />
    </g>
  </svg>
)
